import { ChevronUpIcon } from "@heroicons/react/24/solid";
import { Section } from "../App";
import { previousSectionLink } from "../logic";

interface TopNavigationArrowProps {
  currentSection: Section;
}

export default function TopNavigationArrow(props: TopNavigationArrowProps) {
  const { currentSection } = props;

  return (
    <div className="fixed top-0 w-full flex justify-center">
      <a
        id="previousArrowAnchor"
        className="w-1/2 sm:w-3/4 py-6 flex justify-center"
        href={previousSectionLink(currentSection)}
      >
        <ChevronUpIcon className="w-6 animate-pulse" />
      </a>
    </div>
  );
}
